import { UilYoutube , UilSubject  } from "@iconscout/react-unicons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AddTvSeriesModal from "pages/MovieBox/AddMovie/components/AddTvSeriesModal";

export default function AddMovieModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [showTvSeriesModal, setShowTvSeriesModal] = useState(false);

  if (!isOpen) return null;

  const handleTvSeriesSubmit = (data) => {
    console.log("TV Series data:", data);
    // Handle the TV series data submission here
    // You might want to make an API call or dispatch an action
  };

  return (
    <>
      <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-200 rounded-xl shadow-lg z-30">
        <ul className="py-2 text-sm text-gray-700">
         
          <li>
            <button
              onClick={() => {
                onClose();
                navigate("/movie-box/add-movie?media_type=movie");
              }}
              className="flex items-center w-full px-4 py-3 hover:bg-gray-100 transition"
            >
              <UilYoutube  className="mr-3 text-black" size={20} />
              <span className="text-gray-800 font-medium">Add Single Movie</span>
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                // onClose();
                setShowTvSeriesModal(true);
              }}
              className="flex items-center w-full px-4 py-3 hover:bg-gray-100 transition"
            >
              <UilSubject  className="mr-3 text-black-600" size={20} />
              <span className="text-gray-800 font-medium">Add TV Series</span>
            </button>
          </li>
        </ul>
      </div>

      <AddTvSeriesModal 
        isOpen={showTvSeriesModal} 
        onClose={() => setShowTvSeriesModal(false)} 
        onSubmit={handleTvSeriesSubmit}
      />
    </>
  );
}
